module.exports = __webpack_public_path__ + "./docs/img/big-icon-tutorial.5142bfd350231aa5880c1cb1bea9077f.svg";